import React, { useState } from "react";
import { Calendar } from 'primereact/calendar';
import { Message } from 'primereact/message';
import { Button } from 'primereact/button';

import { esObjetoVacio } from '../../servicios/ServicioObjetos';
import servicioDescargaArchivos from '../../servicios/ServicioDescargaArchivos';

const es = {
    firstDayOfWeek: 1,
    dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
    dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
    dayNamesMin: ["D", "L", "M", "Mi", "J", "V", "S"],
    monthNames: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
    monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"]
};

export const ReporteExtemporaneo = () => {

    const [busqueda, setBusqueda] = useState({});
    const [errores, setErrores] = useState({});

    const handleChange = (e, mayusculas) => {
        const { name, value } = e.target;
        let elValor = value;

        if (mayusculas) {
            if (elValor && typeof elValor !== 'object')
                elValor = elValor.toUpperCase();
        }
        setBusqueda(valoresPrevios => ({
            ...valoresPrevios,
            [name]: elValor
        }));
    };

    const buscar = () => {
        let losErrores = validarFrm();
        setErrores(losErrores);
        if (esObjetoVacio(losErrores)) {
            buscarBackEnd();
        }
    }

    const validarFrm = () => {
        let errores = {};
        if (esObjetoVacio(busqueda) || esObjetoVacio(busqueda.fecha)) {
            errores.fecha = "La fecha es requerida";
        }
        return errores;
    }

    const buscarBackEnd = () => {
        servicioDescargaArchivos.descargaArchivo('cruce/reporte_quincenal.json',
            { fecha: busqueda.fecha.getTime() });
    }

    return (<div>
        <div className="card card-w-title">
            <h1>Nru Extemporaneos</h1>
            <h5>En este módulo podrás consutar cuales NRU se han timbrado en el mes posterior a su expedición</h5>
            <h5>- Por ejemplo los NRU del mes de Enero de 2023, solo se pueden timbrar hasta el 15 de Febrero de 2023</h5>
            <h5>- Este módulo te exportará un reporte (.xlsx) de aquellos NRU que son de Enero de 2023 pero que se timbraron del 1 al 15 de Febrero de 2023 (Se toma esto como ejemplo pero aplica para todos los meses)</h5>
            <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-2">
                    <span><strong>Fecha Búsqueda:</strong></span>
                </div>
                <div className="p-col-12 p-md-4">
                    <Calendar id="fecha" name="fecha" value={busqueda.fecha || ''}
                        onChange={(e) => handleChange(e, false)}
                        className={errores.fecha ? 'p-error' : ''}
                        locale={es} view="month"
                        dateFormat="MM/yy" yearNavigator={true} yearRange="2020:2030" />
                    {errores.fecha ? <div><br /> <Message severity="error"
                        text={errores.fecha} /> </div> : null}
                </div>
                <div className="p-col-12 p-md-2">
                    <Button
                        label="Buscar"
                        icon="pi pi-search"
                        onClick={buscar}
                        className="p-button-rounded p-button-success" />
                </div>
            </div>
        </div>
    </div>);
}